import { useStaticQuery, graphql } from 'gatsby'

export const useFooterQuery = () => {
  const { wp, footerMenu1, footerMenu2 } = useStaticQuery(graphql`
    query FooterQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            logo {
              sourceUrl
            }
            logoAltText
            phoneNumber
            footer {
              socialMedia {
                socialMediaIcon {
                  sourceUrl
                }
                socialMediaLink {
                  url
                }
              }
              contact {
                label
                addressLabel
                addresses {
                  address
                }
                phoneText
              }
              officeHours {
                label
                text
              }
              copyright
              nexvelLogo {
                sourceUrl
              }
              nexvelLink {
                url
              }
            }
          }
        }
      }
      footerMenu1: allWpMenuItem(
        filter: { parentDatabaseId: { eq: 0 }, locations: { eq: FOOTER_MENU_1 } }
      ) {
        nodes {
          menu {
            node {
              name
            }
          }
          label
          path
        }
      }
      footerMenu2: allWpMenuItem(
        filter: { parentDatabaseId: { eq: 0 }, locations: { eq: FOOTER_MENU_2 } }
      ) {
        nodes {
          menu {
            node {
              name
            }
          }
          label
          path
        }
      }
    }
  `)
  return { wp, footerMenu1, footerMenu2 }
}
